export default __webpack_public_path__ + "static/media/sv_13.78fc1db9.webp";